import { CSSProperties } from 'react';
import { ColumnAlingment, ITableDataSet } from '../../interfaces/type1/ITableDataSet';
import './Table.css';



export default function Table(props: { Data: ITableDataSet }) {

    let getTextAlign = (i: number): CSSProperties => {

        return props.Data.ColumnsAlingments && props.Data.ColumnsAlingments.Count() > i ?
            {
                textAlign: (() => {

                    switch (props.Data.ColumnsAlingments[i]) {
                        case ColumnAlingment.START: return 'start';
                        case ColumnAlingment.CENTER: return 'center';
                        case ColumnAlingment.END: return 'end';
                    }
                })()
            } : {}
    }

    return (

        <div className='TableComponent'>
            <h1 style={{ textAlign: 'center' }}>Valor tabulado</h1>
            <br />
            <table>
                <thead>
                    <tr>
                        {
                            props.Data.Columns && props.Data.Columns.map((s, i) => (<th key={Math.random()} style={{ ...getTextAlign(i) }}>{s}</th>))
                        }
                    </tr>

                </thead>
                <tbody>
                    {
                        props.Data.Rows && props.Data.Rows.Select(s => (
                            <tr key={Math.random()} >
                                {s.map((e, i) => <td style={{ ...getTextAlign(i) }} key={Math.random()}>{e}</td>)}
                            </tr>
                        ))
                    }
                    {
                        props.Data.Rows && props.Data.Totals &&

                        <tr>

                            {
                                props.Data.Totals.map((s, i) => (
                                    <td key={Math.random()} className='TotalsRow' style={{ ...getTextAlign(i) }}>{s}</td>
                                ))
                            }

                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}